import React from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { User, Calendar, Phone } from "lucide-react";

interface PatientDetailsCardProps {
  patientName: string;
  emr: string;
  gender: string;
  dateOfBirth: string;
  age: number;
  phoneNumber: string;
  onPatientClick?: () => void;
}

export const PatientDetailsCard: React.FC<PatientDetailsCardProps> = ({
  patientName,
  emr,
  gender,
  dateOfBirth,
  age,
  phoneNumber,
  onPatientClick,
}) => {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric'
    });
  };

  // Truncate name if it exceeds 200 characters
  const truncateName = (name: string, maxLength: number = 200) => {
    if (name.length > maxLength) {
      return name.substring(0, maxLength) + '...';
    }
    return name;
  };

  const displayName = truncateName(patientName);
  const isTruncated = patientName.length > 200;

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <Button
          variant="link"
          className="p-0 h-auto text-cyan-600 hover:text-cyan-600/80 font-medium text-left max-w-[300px] truncate"
          onClick={onPatientClick}
          title={isTruncated ? patientName : undefined}
        >
          {displayName}
        </Button>
      </div>
      
      <div className="space-y-1 text-sm text-muted-foreground">
        <div className="flex items-center gap-2">
          <User className="h-3 w-3" />
          <span>EMR - <span className="text-foreground">{emr}</span></span>
          <Badge variant="outline" className="text-xs">
            {gender}
          </Badge>
        </div>
        
        <div className="flex items-center gap-2">
          <Calendar className="h-3 w-3" />
          <span>DoB - <span className="text-foreground">{formatDate(dateOfBirth)}</span></span>
          <span>Age - <span className="text-foreground">{age}</span></span>
        </div>
        
        <div className="flex items-center gap-2">
          <Phone className="h-3 w-3" />
          <span>Ph - <span className="text-foreground">{phoneNumber}</span></span>
        </div>
      </div>
    </div>
  );
};